export const API_DOMAIN = 'https://api.disadus.app'
// export const API_DOMAIN = process.env.NODE_ENV === 'development' ? 'http://localhost:443': 'https://api.disadus.app'
// export const API_DOMAIN = 'http://192.168.0.69:443'
export const CHAT_API_DOMAIN = `https://chatapi.disadus.app`
// export const CHAT_API_DOMAIN = 'https://localhost:888'
export const scrollbar = ` scrollbar-thin scrollbar-thumb-rounded scrollbar-thumb-gray-300 hover:scrollbar-thumb-gray-500 scrollbar-track-gray-200
dark:scrollbar-track-gray-800 dark:scrollbar-thumb-gray-500`
export const AppVersion = '2.0.5'

